import { AbstractView } from "../../../../../abstracts/modules/AbstractView";
import { UCSoundNames, UCSpineNames } from "../../../../assetsLoader/UCAssetsNames";
import { UCFreespinIntroScreen } from "../freespin/UCFreespinIntroScreen";

export class UCSuperFreespinIntroScreen extends UCFreespinIntroScreen {
    constructor(parentContainer: AbstractView) {
        super(parentContainer, `UCSuperFreespinIntroScreen`);
    }

    protected override getTextureName(): string {
        return `SFS_INTRO`;
    }

    protected getSpineName(): string {
        return UCSpineNames.SFS_INTRO;
    }

    protected override getScreenCustomName(): string {
        return `Super Freespin Intro`;
    }

    protected getFsLeftDefaultText(): string {
        return `Super Freespins won:`;
    }

    protected addContinueButton() {
        super.addContinueButton();

        this.continueButton.y = 1020;
    }

    protected override addSpinsNameAndText() {
        super.addSpinsNameAndText();

        this.spinsNameSprite.position.set(837, 594);
        this.spinsTextSprite.position.set(837, 658);
    }

    protected override addFreespinsLeftText() {
        super.addFreespinsLeftText();

        this.fsLeftText.position.set(837, 526);
    }

    protected getIntroStartSoundName(): string {
        return UCSoundNames.SFS_INTRO_START;
    }

    protected getIntroLoopSoundName(): string {
        return UCSoundNames.SFS_INTRO_LOOP;
    }

    protected getPreviousModeSoundName(): string {
        return UCSoundNames.FREESPIN_MUSIC;
    }
}
